<template>
  <div class="detail-charts">
    <div class="chart-panel">
        <transition name="fade">
            <div v-if="loading" class="loading-wrapper">
                <BaseSpinner text="info.loading_data" />
            </div>
        </transition>
      <div class="chart-panel__header" :id="`test-detail-chart-${sensor.name.replace(/\s+/g, '_').toLowerCase()}`">
        <div>{{ $t(`metrics.${sensor.name.toLowerCase().replaceAll(" ","_").replace("%","_")}`) }}</div>
          <div class="chart-panel__info__period" @click="toggleChartPeriodSelect2" v-click-outside="hideChartPeriodSelect2" v-responsive.sm.xs.md>
              <div style="display: flex;">
                  <span>{{ selectedPeriod.name }}</span>
                  <BaseIcon icon="chevron-down" />
              </div>
              <transition name="fadeUp">
                  <BaseSelectList
                          v-if="showChartPeriodSelect2"
                          :items="chartPeriodOptions"
                          :active="selectedPeriod"
                          @onSelect="setChartPeriod"
                          style="z-index: 13;"
                  />
              </transition>
          </div>
        <div v-if="false" class="chart-panel__header__settings">
          <BaseIcon icon="settings" @click="toggleChartSettings" />
          <transition name="fadeUp">
            <div v-if="showChartSettings" class="graph-settings"></div>
          </transition>
        </div>
      </div>
      <div class="chart-panel__info" v-responsive.lg.xl.md>
          <div class="chart-panel__info__min" v-if="showMinMax(sensor.name)">
              <span class="description">{{ $t('detail.min_value') }}</span>
              <span class="value">{{ minValue ? minValue.toFixed(2) : 'N/A' }}{{ hasValues && minValue ? sensor.unit : ''}}</span>
          </div>
          <div class="chart-panel__info__actual" v-if="showLast(sensor.name)">
              <span class="description">{{ $t('detail.last_value') }}</span>
              <span class="value">{{ lastValue ? lastValue.toFixed(2) : 'N/A' }}{{ hasValues && lastValue ? sensor.unit : ''}}</span>
          </div>
          <div class="chart-panel__info__max" v-if="showMinMax(sensor.name)">
              <span class="description">{{ $t('detail.max_value') }}</span>
              <span class="value">{{ maxValue ? maxValue.toFixed(2) : 'N/A' }}{{hasValues && maxValue ? sensor.unit : ''}}</span>
          </div>
        <div class="chart-panel__info__period test-button-time-range" @click="toggleChartPeriodSelect" v-click-outside="hideChartPeriodSelect" v-responsive.lg.xl>
          <div style="display: flex;">
            {{ $t('detail.select_data') }}:
            <span>{{ computedPeriodOption.name }}</span>
            <BaseIcon icon="chevron-down" />
          </div>
          <transition name="fadeUp">
            <BaseSelectList
              v-if="showChartPeriodSelect"
              :items="chartPeriodOptions"
              :active="computedPeriodOption"
              @onSelect="setChartPeriod"
              style="z-index: 13;"
            />
          </transition>
        </div>
        <div v-if="showCustomDateRange" class="date-range-picker">
          <date-range-picker
              ref="picker"
              :opens="'top'"
              :showControls="true"
              :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
              :singleDatePicker="false"
              @update="setChartcustomPeriod"
              @click="checkOpen"
              :theme="rangePickerTheme"
              :submitTitle="$t('buttons.apply_range')"
              :dateFormat="dateFormat"
          >
          </date-range-picker>
        </div>
      </div>
      <div class="chart-panel__chart">
        <apexchart height="100%" width="100%" :type="getApexType(sensor.name)" :options="chartOptions" :series="series">
        </apexchart>
      </div>
    </div>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts';
import { chartPeriods } from '@/config/charts';
import { mapGetters } from 'vuex';
import 'vue-mj-daterangepicker/dist/vue-mj-daterangepicker.css';

export default {
  name: 'DetailChartPanel',
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    sensor: {
      type: Object,
      required: true,
    },
    unit: {
      type: Object,
      required: true,
    },
    loadedData: {
      type: Object,
      default() {
        return{};
      },
    },
  },
  created() {
    // this.setChartData(this.getDateFromToday(-1, 0, 0), this.getDateFromToday(0, 0, 0));
    // this.transformData(this.loadedData);
    this.showCustomDateRange = false;
    if (!this.sensor.name) {
      this.loading = false;
    }
  },
  data() {
    return {
      loading: true,
      series: [
        {
          name: 'Temperature',
          data: [],
        },
      ],
      chartFromDate: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate() - 1}`,
      currentTime: new Date(),
      pageTime: new Date(),
      isUpdatingAvailable: this.unit.nextMessage !== null,
      timeIntervalToWait: 2,
      showChartSettings: false,
      showChartPeriodSelect: false,
      showChartPeriodSelect2: false,
      selectedPeriod: { id: 4, value: 'day' , name: this.$t('interval.day') },
    };
  },
  computed: {
    ...mapGetters('tentacle', ['timeFormat']),
    minutesSinceLastData() {
      if (this.isUpdatingAvailable) {
        return (this.currentTime - new Date(this.unit.nextMessage.date)) / 1000 / 60;
      }

      return 0;
    },
    timeSinceLastMessage() {
      if (this.isUpdatingAvailable) {
        return (this.pageTime - new Date(this.unit.nextMessage.date)) / 1000 / 60;
      }

      return 0;
    },
    computedPeriodOption() {
      const option = this.selectedPeriod;
      option.name = this.$t(`interval.${option.value}`);
      return option;
    },
    chartOptions() {
      let sensors = this.unit.sensors.filter(item => item.name.includes(this.sensor.name));
      return {
        chart: {
          toolbar: {
            show: true,
          },
        },
        colors: ['#b2de4d', '#64b5f6', '#ffb74d', '#f47f7f',
              '#a1887f', '#7da453', '#2286c3', '#c75b39',
              '#af4448', '#725b53'],
        stroke: {
          curve: 'straight',
        },
        annotations: {
          show: true,
            yaxis: [
                {
                    y: sensors[0].minCrit,
                    strokeDashArray: 6,
                    borderColor: '#6fbdea',
                    label: {
                        borderColor: '#6fbdea',
                        style: {
                            color: '#fff',
                            background: '#6fbdea',
                            fontSize: '1.5em',
                        },
                        text: '',
                    },
                },
                {
                    y: sensors[0].minAttention,
                    strokeDashArray: 3,
                    borderColor: '#49d300',
                    label: {
                        borderColor: '#49d300',
                        style: {
                            color: '#fff',
                            background: '#49d300',
                            fontSize: '1.5em',
                        },
                        text: '',
                    },
                },
                {
                    y: sensors[0].maxAttention,
                    strokeDashArray: 3,
                    borderColor: '#f1a500',
                    label: {
                        borderColor: '#f1a500',
                        style: {
                            color: '#fff',
                            background: '#f1a500',
                            fontSize: '1.5em',
                        },
                        text: '',
                    },
                },
                {
                    y: sensors[0].maxCrit,
                    strokeDashArray: 6,
                    borderColor: '#ff5a5a',
                    label: {
                        borderColor: '#ff5a5a',
                        style: {
                            color: '#fff',
                            background: '#ff5a5a',
                            fontSize: '1.5em',
                        },
                        text: '',
                    },
                }
                ],
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          fontSize: '14px',
          fontFamily: 'Rubik, Helvetica, Arial, sans-serif',
          offsetY: -10,
          labels: {
            colors: '#acb4c5',
          },
          itemMargin: {
            horizontal: 10,
            vertical: 10,
          },
        },
        dataLabels: {
          enabled: false,
          formatter: (val, opts) => `${val} ${this.sensor.unit}`,
          textAnchor: 'middle',
          style: {
            fontSize: '12px',
            fontFamily: 'Rubik, Helvetica, Arial, sans-serif',
          },
        },
        fill: {
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100],
          },
        },
        grid: {
          show: true,
          borderColor: '#eee',
          strokeDashArray: 5,
          position: 'back',
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
        },
        noData: {
          text: this.$t('detail.missing'),
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: 'Rubik, Helvetica, Arial, sans-serif',
          },
        },
        tooltip: {
          enabled: true,
          style: {
            fontSize: '12px',
            fontFamily: 'Rubik, Helvetica, Arial, sans-serif',
          },
          custom: ({ series, seriesIndex, dataPointIndex, w }) => {
              let tooltipBody = '';
              let allSeries = w.config.series

              allSeries.forEach((series, index) => {
                  if (
                      series.data.length > 0 &&
                      typeof series.data[dataPointIndex] !== 'undefined' &&
                      typeof series.data[dataPointIndex].y !== 'undefined' &&
                      series.data[dataPointIndex].y !== null &&
                      w.config.series[seriesIndex].data[dataPointIndex].x === series.data[dataPointIndex].x
                  ) {
                      let seriesName = series.name;
                      let value = `${seriesName}: ${series.data[dataPointIndex].y} ${this.sensor.unit}`;
                      const source = w.globals.seriesZ[index][dataPointIndex]['source'];
                      const sourceFormatted = source !== '' ? this.$t('network.' + w.globals.seriesZ[index][dataPointIndex]['source']) : '';
                      const sourceImg = source !== '' ? `<img src="/${source}_logo.png" alt="${sourceFormatted}" class="custom-tooltip-network-logo">` : '';
                      tooltipBody += '<div class="custom-tooltip-value-wrapper">'
                                          + '<div class="custom-tooltip-marker" style="background-color: ' + w.globals.colors[index] + '"></div>'
                                          + '<div class="custom-tooltip-value">'
                                                + '<div>'
                                                     + value
                                                + '</div>'
                                                + '<div class="custom-tooltip-value-raw">'
                                                      + sourceImg
                                                      + ' Raw: ' + w.globals.seriesZ[index][dataPointIndex]['raw']
                                                + '</div>'
                                            + '</div>'
                                      + '</div>';
                  }
              });

              const newDate = new Date(w.config.series[seriesIndex].data[dataPointIndex].x);
              const outDate = this.moment(newDate).format(this.timeFormat ? 'DD MMM YYYY, hh:mm a' : 'DD MMM YYYY, HH:mm');

              return (
                  '<div class="custom-tooltip" >' +
                  '<div class="custom-tooltip-header">' +
                  outDate +
                  "</div>" +
                  tooltipBody +
                  "</div>"
              );
          },
          marker: {
            show: true,
          },
        },
        yaxis: {
          decimalsInFloat: 2,
          labels: {
            show: true,
            style: {
              color: '#acb4c5',
              fontSize: '12px',
              fontFamily: 'Rubik, Helvetica, Arial, sans-serif',
            },
          },
        },
        xaxis: {
          type: 'datetime',
          labels: {
            // format: 'dd MMM yyyy',
            style: {
              colors: '#acb4c5',
              fontSize: '12px',
              fontFamily: 'Rubik, Helvetica, Arial, sans-serif',
            },
          },
        },
      };
    },
    chartPeriodOptions() {
      chartPeriods.forEach(item => item.name = this.$t(`interval.${item.value}`));
      return chartPeriods;
    },
    hasValues() {
      return this.series.length > 0 && this.series[0].data.length > 0;
    },
      minValue() {
          if (this.hasValues) {
              let seriesMin = [];
              this.series.forEach((series, index) => {
                  if (series.data.length > 0) {
                      seriesMin.push(series.data.reduce((total, current) => {
                          if (typeof current['y'] !== 'undefined' && current['y'] !== null && current['y'] < total) {
                              total = current['y'];
                          }
                          return Number(total);
                      }, series.data[0]['y']));
                  }
              });
              return Math.min(...seriesMin);
          }
          return NaN;
      },
    lastValue() {
      const { data } = this.series[0];
      return this.hasValues ? Number(data[data.length - 1]['y']) : NaN;
    },
      maxValue() {
          if (this.hasValues) {
              let seriesMax = [];
              this.series.forEach((series, index) => {
                  if (series.data.length > 0) {
                      seriesMax.push(series.data.reduce((total, current) => {
                          if (typeof current['y'] !== 'undefined' && current['y'] > total) {
                              total = current['y'];
                          }
                          return Number(total);
                      }, series.data[0]['y']));
                  }
              });
              return Math.max(...seriesMax);
          }
          return NaN;
      },
  },
  watch: {
    loadedData(newVal, oldVal) {
      this.updateData(this.unit.typeId, newVal);
    },
    minutesSinceLastData(newVal) {
      if (this.isUpdatingAvailable && newVal >= this.timeIntervalToWait && this.timeSinceLastMessage < this.messageInterval()) {
        this.autoUpdateCharts();
        this.timeIntervalToWait = this.timeIntervalToWait + this.messageInterval();
      }
    },
  },
  methods: {
    measurementIntervalMinutes() {
      let span = 15;
      if (typeof this.unit.payload.userMeasurementIntervalSpan !== 'undefined') {
        if ( this.unit.payload.userMeasurementIntervalSpan <= 15 && this.unit.payload.userMeasurementIntervalSpan >= 1) {
          span = this.unit.payload.userMeasurementIntervalSpan;
        }
      }

      return span;
    },
    messageInterval() {
      let minutes = 15;
      if (typeof this.unit.version !== 'undefined' && this.unit.version.minuteSelection) {
        minutes = this.measurementIntervalMinutes();
      }

      return ((parseInt(this.unit.payload.userOmittedMessages) + 1) * minutes) * parseInt(this.unit.payload.userMessagesInInterval);
    },
    updateCurrentTime() {
      this.currentTime = new Date();
    },
    getApexType(sensorName) {
        switch (sensorName) {
            case 'Events':
                return 'scatter';
            case 'Angles':
                return 'line';
            case 'Currents':
                return 'line';
            default:
                return 'line';
        }
    },
    showMinMax(sensorName) {
       return sensorName !== 'Events';
    },
    showLast(sensorName) {
       return sensorName !== 'Events' && typeof this.loadedData[sensorName] !== 'undefined' && this.loadedData[sensorName].length === 1;
    },
    getIntervalOption(value) {
      return this.chartPeriodOptions.find(item => item.value === value);
    },
    updateData(typeId, newData) {
      const filtered = this.sensor.name.length > 1 ? newData[this.sensor.name] : [];

      if (typeof newData !== 'string' && Object.keys(filtered).length > 0) {
        this.loading = true;
        const series = [];
        filtered.forEach((data) => {
              if (data.id) {
                  let name = data.name.toLowerCase().replace(' ','_');
                  const sensor = {
                      name: this.$t(`metrics.${name}`),
                      data: [],
                  };

                  let chartData = [];
                  if (data.values.length > 0) {
                    chartData = data.values;
                    for (let i = 1; i < chartData.length; i++) {
                      if (chartData[i].timestamp - chartData[i - 1].timestamp > (4.5 * 60 * 60)) {
                        const item = {
                          value: null,
                          rawValue: null,
                          timestamp: (parseInt(chartData[i].timestamp) + parseInt(chartData[i - 1].timestamp)) / 2,
                        };
                        chartData.splice(i, 0, item);
                      }
                    }
                  }

                  sensor.data = chartData.reduce((total, current) => {
                      let checkedRawValue = current.rawValue === null ? '-' : current.rawValue;
                      const timeInMiliseconds = Number(current.timestamp) * 1000;
                      total.push({ x: timeInMiliseconds, y: current.value, z: checkedRawValue });
                      return total;
                  }, []);
                  series.push(sensor);
              }
          });
        this.series = series;
      }
      this.loading = false;
    },
	  calcDateFromToday(year, month, day) {
		  let cDate = new Date().getDate() + day;
		  let cMonth = new Date().getMonth() + 1 + month;
		  let cYear = new Date().getFullYear() + year;

		  if(!this.isJanuary() && cDate < 1){
		      let daysTotal = new Date(cYear, --cMonth, 0).getDate();
              cDate = daysTotal + cDate;
          }
		  //checks if day goes into december and counts back days
		  if (this.isJanuary() && cDate < 1) {
			  cDate = 31 + cDate;
			  cMonth = 12;
			  cYear = cYear - 1;
		  }
		  //checks if month goes back to previous year and counts from 12
		  if (this.isPreviousYearMonth(month)) {
			  cMonth = 12 + cMonth;
			  cYear = cYear - 1;
		  }
		  return `${cYear}-${cMonth}-${cDate}`;
	  },
	  getDateFromToday() {
		  return `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`;
	  },
	  isJanuary(){
		  return (new Date().getMonth() + 1) == 1;
	  },
	  isPreviousYearMonth(month){
		  return ((new Date().getMonth() + 1 + month) <= 0 ) ;
	  },
    setChartData(fromDate, toDate) {
      this.loading = true;
      const filter = [{ name: this.sensor.name, from: fromDate, to: toDate }];
        const data = {tentacle: this.unit.id, filter: filter};
      this.$store.dispatch('tentacle/setDetailMeasurement', data).then((resolve) => {
        let chartData = [];
        if (resolve.data) {
          chartData = resolve.data;
        }
        this.updateData(this.unit.typeId, chartData);
      });
    },
    toggleChartSettings() {
      this.showChartSettings = !this.showChartSettings;
    },
    toggleChartPeriodSelect() {
      this.showChartPeriodSelect = !this.showChartPeriodSelect;
    },
    toggleChartPeriodSelect2() {
      this.showChartPeriodSelect2 = !this.showChartPeriodSelect2;
    },
    hideChartPeriodSelect2() {
      this.showChartPeriodSelect2 = false;
    },
    hideChartPeriodSelect() {
      this.showChartPeriodSelect = false;
    },
    setChartcustomPeriod(picker) {
      this.showCustomDateRange = false;
      var dateFrom = new Date(picker.from);
      var dateTo = new Date(picker.to);
      var dateFromString = this.moment(dateFrom).format("YYYY-MM-DD");
      var dateToString = this.moment(dateTo).format("YYYY-MM-DD");

      this.setChartData(dateFromString, dateToString);
      this.chartFromDate = dateFromString;
    },
    setChartPeriod(item) {
      this.showChartPeriodSelect = !this.showChartPeriodSelect;
      if (item.value === 'year' && this.selectedPeriod.value !== 'year') {
        this.chartFromDate = this.calcDateFromToday(-1, 0, 0);
      } else if (item.value === 'month' && this.selectedPeriod.value !== 'month') {
        this.chartFromDate = this.calcDateFromToday(0, -1, 0);
      } else if (item.value === 'week' && this.selectedPeriod.value !== 'week') {
        this.chartFromDate = this.calcDateFromToday(0, 0, -6);
      } else if (item.value === 'day' && this.selectedPeriod.value !== 'day') {
        this.chartFromDate = this.calcDateFromToday(0, 0, -1);
      } else if (item.value === 'customRange') {
        this.showCustomDateRange = true;
      }

      this.setChartData(this.chartFromDate, this.getDateFromToday());
      this.selectedPeriod = item;
    },
    autoUpdateCharts() {
      this.setChartData(this.chartFromDate, this.getDateFromToday());
    },
  },
  mounted() {
    this.interval = setInterval(this.updateCurrentTime, 180000); // Update current time every 3 minutes
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped>
.chart-panel {
    position:relative;
  margin-bottom: 4rem;
  border-radius: 2rem;
  background-color: #fff;
  box-shadow: 0 0 5px rgba(100, 116, 160, 0.1);
    @media only screen and (max-width: 1199px) {
        width: 90%;
        margin:auto;
        margin-top: 2em;
    }
    @media only screen and (min-width: 1200px) and (max-width: 1400px) {
        margin-left: 2%;
        width: 94%;
    }

  &__header {
    padding: 0 3rem;
    height: 6rem;
    border-bottom: 0.1rem solid $border-color;
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 1.4rem;
    color: $grey;

    &__settings {
      position: relative;
      margin-left: auto;
      cursor: pointer;
      display: flex;
      align-items: center;

      svg {
        width: 1.8rem;
        height: 1.8rem;
      }

      .icon {
        fill: $grey;
        width: 1.8rem 1.8rem;
      }

      .graph-settings {
        position: absolute;
        z-index: 12;
        top: 3rem;
        right: -1rem;
        padding: 1rem;
        width: 20rem;
        height: 10rem;
        background-color: $white;
        box-shadow: 0 0.5rem 1.5rem 0 rgba(37, 44, 97, 0.15),
          0 0.2rem 0.4rem 0 rgba(93, 100, 148, 0.2);
      }
    }
  }

  &__info {
    padding: 0 3rem;
    display: flex;
    height: 8rem;
    align-items: stretch;

    &__min,
    &__actual,
    &__max {
      min-width: 18rem;
      display: flex;
      height: 100%;
      align-items: center;
      font-size: 3rem;
      font-weight: 700;
      color: $dark;

      .value {
        color: $grey;

        &.max {
          color: $max-color;
        }

        &.min {
          color: $min-color;
        }
      }

      .description {
        font-size: 1.1rem;
        width: 4.6rem;
        display: inline-flex;
        align-items: center;
        height: 3rem;
        text-align: end;
        margin-right: 2rem;
        position: relative;

        &:after {
          content: '';
          display: inline-block;
          position: absolute;
          right: -1rem;
          width: 0.1rem;
          height: 100%;
          background-color: $very-light-grey;
        }
      }
    }

    &__actual {
      .value {
        color: $company-color;
      }
    }

    &__period {
      position: relative;
      display: flex;
      align-items: center;
      margin-left: auto;
      font-weight: 500;
      color: $grey;
      align-self: center;
      padding: 1.5rem;
      border-radius: 0.5rem;
      cursor: pointer;
      font-size: 1.2rem;
      transition: all 0.4s;

      svg {
        width: 1.2rem;
        height: 1.2rem;
      }

      &:hover {
        background-color: $bg;
      }

      span {
        margin-left: 1rem;
        min-width: 7rem;
        color: $dark;
      }
    }
  }

  &__chart {
    padding: 0 3rem;
    min-height: 28rem;
      width: 100%;
      height: 280px;
      @media only screen and (max-width: 991px) {
          padding: 0;
      }
  }

  &__footer {
    height: 6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    font-weight: 500;
    color: $grey;

    span {
      width: 2rem;
      height: 0.6rem;
      border-radius: 0.2rem;
      background-color: $company-color;
      margin-right: 0.5rem;
    }
  }
}
.loading-wrapper {
    position: absolute;
    border-radius: 2rem;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
}
</style>
<style>
.custom-tooltip {
    border: 1px solid lightgrey;
    border-radius: 5px;
    z-index: 999;
    background-color: #fff;
    display: flex;
    flex-direction: column;
}

.custom-tooltip-header {
    font-size: 1.2rem;
    padding: 7px;
    color: black;
    background-color: #efefef;
    border-bottom: 1px solid lightgrey;
}

.custom-tooltip-marker {
    margin-top: 9px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
}

.custom-tooltip-value-wrapper {
    padding: 7px;
    display: flex;
    flex-direction: row;
}

.custom-tooltip-network-logo {
    margin-right: 3px;
    max-width: 13px;
    max-height: 15px;
    margin-bottom: 2px;
}

.custom-tooltip-value {
    font-size: 1.3rem;
    padding: 0 7px;
    display: flex;
    flex-direction: column;
}

.custom-tooltip-value-raw {
    display: flex;
    align-items: center;
    margin-top: 2px;
    font-size: 1.1rem;
}

.date-range-picker {
    z-index: 999;
    background-color: #fff;
    right: 30px;
    position: relative;
}
.mj-daterange-picker {
    background-color: #fff;
}
.date-range-picker .mj-daterange-picker-controls .mj-daterange-picker-submit {
    display: inline-flex !important;
}
.chart-panel__info__period span {
    margin-right: 1rem;
}
</style>
